import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SessionStorageService } from "./session-storage.service";



@Injectable({
    providedIn: 'root'
})
export class UrlParamsService {

    constructor(
        private sessionStorageService: SessionStorageService,
        private router: Router
    ) { }


    colocarParametrosURL() {
        const { productId, origemComercialId } = this.sessionStorageService.getEnvConfig();
        if (productId && origemComercialId) {
            this.router.navigate(
                ["/"],
                { queryParams: { productId: `${productId}`, sourceId: `${origemComercialId}` } }
            );
        } else {
            this.router.navigate(["/"]);
        }

    }
}
